<template>
  <div class="animated fadeIn step-container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <h2>{{$t('message.dashboard.title')}}</h2>
      </div>

      <div v-if="loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block text-center">
            <div style="width:60px; margin:auto;"> 
              <dot-loader size='60px'></dot-loader>
            </div>
          </div>
        </div>
      </div>

      <!-- Notifications -->
      <div v-if="notificationShow && !loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block">
            <h4>{{$t('message.dashboard.notification')}}</h4>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" v-for="notiItem in notifications" :key="notiItem.id">
              <div class="noti-item-card">
                <p class="noti-item-message mb-0" v-html="notiItem.message"></p>
                <button type="button" class="noti-item-btn btn btn-warning btn-lg" @click.prevent="actionProcess(notiItem.type)">{{notiItem.action}}</button>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- Appointment Chart -->
      <div v-if="!loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block">
            <h4>{{$t('message.dashboard.appointment_m')}}</h4>
          </div>

          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              <h6 class="apm-cnt-title">{{$t('message.dashboard.appointment')}}</h6>
              <h2>{{appointmentStatChartData.count}}</h2>
              <dashboard-line-chart class="chart-wrapper px-3" style="height:12rem;" :chartData="appointmentStatChartData" />
            </li>
            <li class="list-group-item">
              <a href="javascript:void(0)" @click.prevent="gotoAppointments">{{$t('message.dashboard.view_all_appointment')}}</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Statistics Chart -->
      <div v-if="!loading" class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-block">
            <h4>{{$t('message.dashboard.visitor_m')}}</h4>
          </div>

          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              <h6 class="apm-cnt-title">{{$t('message.dashboard.visitor')}}</h6>
              <h2>{{viewStatChartData.count}}</h2>
              <dashboard-line-chart class="chart-wrapper px-3" style="height:12rem;" :chartData="viewStatChartData" />
            </li>
            <li class="list-group-item">
              <a href="javascript:void(0)" @click.prevent="gotoAppointments">{{$t('message.dashboard.view_all_visitor')}}</a>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import DashboardLineChart from '@/components/chart/LineChart'
import moment from 'moment'
import DotLoader from 'vue-spinner/src/DotLoader'

const backgroundColor = '#20a8d8'
const borderColor = 'rgba(255,255,255,.55)'

moment.locale('th')

export default {
  components: {
    DashboardLineChart,
    DotLoader
  },
  data () {
    return {
      loading: false,
      appointments: {},
      stats: {},
      notifications: [],
      appointmentStatChartData: {
        count: 0,
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            data: []
          }
        ]
      },
      viewStatChartData: {
        count: 0,
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            data: []
          }
        ]
      }
    }
  },
  computed: {
    notificationShow () {
      return this.notifications.length > 0
    }
  },
  methods: {
    actionProcess (type) {
      if (type === 'appointment') {
        this.gotoAppointmentsView()
      }
    },
    gotoAppointmentsView () {
      this.$router.push({ path: '/appointments', query: { status: 'pending' } })
    }
  },
  created () {
    // Load appointments
    let self = this

    self.notifications = []
    this.$http.get(this.$APP_CONFIG.api.appointments(),
      {
        params: {
          clinic_id: this.$guser.user.clinic.id,
          start: 'all',
          status: 'pending'
        },
        credentials: true
      }).then(res => {
        self.appointments = Object.assign({}, res.body)
        if (self.appointments.total) {
          self.notifications.push({
            id: 1,
            type: 'appointment',
            message: `${this.$t('message.dashboard.notification_appointment_first')}${self.appointments.total}${this.$t('message.dashboard.notification_appointment_last')}`,
            action: this.$t('message.dashboard.notification_action')
          })
        }
      })

    // Load Stats
    if (this.$guser.isClinic()) {
      this.loading = true
      this.$http.get(this.$APP_CONFIG.api.admin.clinic_stats(this.$guser.user.clinic.id)).then(res => {
        self.stats = Object.assign({}, self.stats, res.body)

        if (self.stats.appointmentStat) {
          self.appointmentStatChartData = Object.assign({}, {
            count: 0,
            labels: [],
            datasets: [
              {
                label: '',
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                data: []
              }
            ]
          })
          var appStatByDate = {}
          var viewStatByDate = {}

          let days = moment().daysInMonth()
          var n = 0
          for (n = days; n >= 0; n--) {
            let key = moment().subtract({days: n}).format('YYYY-MM-DD')
            appStatByDate[key] = {
              count: 0,
              date: key
            }
            viewStatByDate[key] = {
              count: 0,
              date: key
            }
          }

          self.stats.appointmentStat.forEach(data => {
            if (data.count && data.date) {
              appStatByDate[data.date] = {
                count: data.count,
                date: data.date
              }
            }
          })

          var key = null
          for (key in appStatByDate) {
            let dataDateObj = appStatByDate[key]
            if (dataDateObj.count >= 0 && dataDateObj.date) {
              self.appointmentStatChartData.datasets[0].data.push(dataDateObj.count)
              self.appointmentStatChartData.labels.push(dataDateObj.date)
              self.appointmentStatChartData.count += dataDateObj.count
            }
          }

          self.viewStatChartData = Object.assign({}, {
            count: 0,
            labels: [],
            datasets: [
              {
                label: '',
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                data: []
              }
            ]
          })
          self.stats.viewStat.forEach(data => {
            if (data.count && data.date) {
              viewStatByDate[data.date] = {
                count: data.count,
                date: data.date
              }
            }
          })

          for (key in viewStatByDate) {
            let dataDateObj = viewStatByDate[key]
            if (dataDateObj.count >= 0 && dataDateObj.date) {
              self.viewStatChartData.datasets[0].data.push(dataDateObj.count)
              self.viewStatChartData.labels.push(dataDateObj.date)
              self.viewStatChartData.count += dataDateObj.count
            }
          }
        }

        self.loading = false
      })
    }
    this.notifications = []
  }
}
</script>

<style lang="scss">
@import "../../assets/base_container";

.noti-item-card {
  display: flex;
  align-items: center;
  vertical-align: middle;

  .noti-item-btn {
    margin-left: 1rem;
  }

  .noti-item-message {
    flex-grow: 1;
    margin-bottom: 0 !important;
    font-size: 1rem;
  }
}

.apm-cnt-title {
  margin-bottom: 0 !important;
  font-size: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?293ae860